import { ENV } from '@/constants';

export const schemaObject_ClothesChanger = {
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@type': 'WebPage',
			'@id': 'https://liftapp.ai/clothes-changer',
			name: 'ree AI Clothes Changer | Try Virtual Outfits Online | Lift',
			description:
				"Try on new outfits instantly with Lift's AI Clothes Changer. No watermark. Explore styles, fashion trends, and creative looks online.",
			url: 'https://liftapp.ai/clothes-changer',
			image: 'https://liftapp.ai/seo-image.webp',
			mainEntity: [
				{ '@id': 'https://liftapp.ai/clothes-changer#product' },
				{ '@id': 'https://liftapp.ai/clothes-changer#howto' },
				{ '@id': 'https://liftapp.ai/clothes-changer#benefits' },
				{ '@id': 'https://liftapp.ai/clothes-changer#faq' },
				{ '@id': 'https://liftapp.ai/clothes-changer#why-lift' },
				{ '@id': 'https://liftapp.ai/clothes-changer#explore-tools' },
				{ '@id': 'https://liftapp.ai/clothes-changer#all-in-one' },
			],
		},
		// product
		{
			'@type': 'Product',
			'@id': 'https://liftapp.ai/clothes-changer#product',
			name: 'AI Clothes Changer',
			description:
				'Try on new looks in seconds with AI Clothes Changer. No watermark. Create yours with Lift now.',
			url: 'https://liftapp.ai/clothes-changer',
			fileFormat: ['image/jpeg', 'image/png'],
			memoryRequirements: 'Max file size: 20MB',
			brand: {
				'@type': 'Brand',
				name: 'Lift',
			},
			aggregateRating: {
				'@type': 'AggregateRating',
				ratingValue: '4.8',
				reviewCount: 130000,
				bestRating: '5',
				worstRating: '1',
			},
			interactionStatistic: [
				{
					'@type': 'InteractionCounter',
					interactionType: { '@type': 'InstallAction' },
					userInteractionCount: 13000000,
				},
			],
		},
		// howto
		{
			'@type': 'HowTo',
			'@id': 'https://liftapp.ai/clothes-changer#howto',
			name: 'How it works',
			step: [
				{
					'@type': 'HowToStep',
					position: 1,
					name: 'Upload your photos',
					text: 'Choose a photo from your device or take one using Lift’s app',
				},
				{
					'@type': 'HowToStep',
					position: 2,
					name: 'Watch the AI swap work its magic',
					text: 'Our AI maps your body, keeps proportions natural, and swaps clothes with photorealistic accuracy — so it looks like you actually wore them',
				},
				{
					'@type': 'HowToStep',
					position: 3,
					name: 'Customize adjustments',
					text: 'Fine-tune your image with easy-to-use editing tools',
				},
				{
					'@type': 'HowToStep',
					position: 4,
					name: 'Download and use',
					text: 'Download your image or publish it straight to your social feeds',
				},
			],
		},
		// benefit
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/clothes-changer#benefits',
			name: 'Who can benefit from AI Clothes Changer?',
			description:
				'Explore how Lift’s AI Clothes Changer helps users test outfit styles virtually — ideal for fashion lovers, content creators, and e-commerce.',
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Perfect for anyone curious about how they’d look in different styles without shopping first',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Fashion lovers can explore new outfits, styles, and trends before buying',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Content creators can level up their posts with eye-catching, creative outfit swaps',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'E-commerce sellers can showcase multiple product shots without hiring models',
				},
				{
					'@type': 'ListItem',
					position: 5,
					name: 'A fast, fun, and premium tool — whether you’re testing styles, making content, or building a brand',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/benefits.a0e20898.webp',
				name: 'AI Clothes Changer by Lift',
				description:
					'Woman in minimal beige outfits under soft shadow lighting',
			},
		},

		// faq
		{
			'@type': 'FAQPage',
			'@id': 'https://liftapp.ai/clothes-changer#faq',
			mainEntity: [
				{
					'@type': 'Question',
					name: 'What is Lift AI Clothes Changer?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift AI Clothes Changer is a premium online tool that swaps outfits in your photos with realistic AI — perfect for trying styles, creating content, or product showcasing.',
					},
				},
				{
					'@type': 'Question',
					name: 'How does Lift AI Clothes Changer work?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Our AI detects your body shape and posture, then overlays new clothes from presets or another photo. Lighting, textures, and proportions are adjusted for a natural fit.',
					},
				},
				{
					'@type': 'Question',
					name: 'Will it look natural?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Yes. The AI keeps your true body proportions, facial details, and expressions intact, while only replacing the clothes for realistic results.',
					},
				},
				{
					'@type': 'Question',
					name: 'Can I download the results without a watermark?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Absolutely. All images generated or edited in Lift can be exported without watermark when you're on the Pro plan. Download them in high-res PNG or JPG — ready for social media, print, ads, or e-commerce.",
					},
				},
			],
		},

		// why lift
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/clothes-changer#why-lift',
			name: 'Why Lift’s AI Clothes Changer stands out',
			description:
				'Discover how Lift’s AI Clothes Changer delivers professional, high-quality, and cross-platform results — without the need for complex tools.',
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Professional results',
					description:
						'Achieve studio-quality images without the need for complex tools',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'AI accuracy',
					description:
						'Smart algorithms deliver enhancements tailored to your specific image',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Cross-platform support',
					description: 'Available on iOS, Android, and Web for seamless access',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Budget-friendly',
					description:
						'Save on costly editing services with Lift’s affordable solution',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/whyUse.ae83a89c.webp',
				name: 'Why use Lift AI Watermark Remover',
				description:
					'Comparison of Lift’s AI Watermark Remover benefits — professional quality, AI accuracy, multi-platform access, and cost savings.',
			},
		},
		// explore
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/clothes-changer#explore-tools',
			name: 'Explore the AI tools',
			description:
				'A curated list of AI-powered tools for image generation, enhancement, background removal, and more – all available on Lift.',
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'SoftwareApplication',
					operatingSystem: 'Web',
					applicationCategory: 'MultimediaApplication',
					position: 13,
					name: 'AI Watermark Remover',
					url: 'https://liftapp.ai/watermark-remover',
					description: 'Remove watermark from image with AI.',
				},
				{
					'@type': 'SoftwareApplication',
					operatingSystem: 'Web',
					applicationCategory: 'MultimediaApplication',
					position: 12,
					name: 'AI Headshot Generator',
					url: 'https://liftapp.ai/headshot-generator',
					description: 'Create a professional headshot with AI.',
				},
				{
					'@type': 'SoftwareApplication',
					operatingSystem: 'Web',
					applicationCategory: 'MultimediaApplication',
					position: 11,
					name: 'AI Image Generator',
					url: 'https://liftapp.ai/image-gen',
					description:
						'Generate original artwork or portraits using text prompts.',
				},
				{
					'@type': 'SoftwareApplication',
					operatingSystem: 'Web',
					applicationCategory: 'MultimediaApplication',
					position: 10,
					name: 'AI Image Upscaler',
					url: 'https://liftapp.ai/image-upscaler',
					description:
						'Increase image resolution to HD without losing quality.',
				},
				{
					'@type': 'SoftwareApplication',
					operatingSystem: 'Web',
					applicationCategory: 'MultimediaApplication',
					position: 9,
					name: 'AI Image Enhancer',
					url: 'https://liftapp.ai/image-enhancer',
					description: 'Enhance photo quality.',
				},
				{
					'@type': 'SoftwareApplication',
					operatingSystem: 'Web',
					applicationCategory: 'MultimediaApplication',
					position: 8,
					name: 'AI Background Remover',
					url: 'https://liftapp.ai/background-remover',
					description: 'Erase and replace backgrounds in one click.',
				},
				{
					'@type': 'SoftwareApplication',
					operatingSystem: 'Web',
					applicationCategory: 'MultimediaApplication',
					position: 7,
					name: 'AI Starter Pack generator',
					url: 'https://liftapp.ai/ai-filters-starter-pack',
					description:
						'Apply a modern stylized look with the Starter Pack aesthetic.',
				},
				{
					'@type': 'SoftwareApplication',
					operatingSystem: 'Web',
					applicationCategory: 'MultimediaApplication',
					position: 6,
					name: 'AI LEGO generator',
					url: 'https://liftapp.ai/ai-filters-lego',
					description: 'Turn your image into a LEGO-style illustration.',
				},
				{
					'@type': 'SoftwareApplication',
					operatingSystem: 'Web',
					applicationCategory: 'MultimediaApplication',
					position: 5,
					name: 'AI Ghibli generator',
					url: 'https://liftapp.ai/ai-filters-ghibli',
					description:
						'Transform your photo into a Ghibli-style cartoon with AI.',
				},
				{
					'@type': 'SoftwareApplication',
					operatingSystem: 'Web',
					applicationCategory: 'MultimediaApplication',
					position: 4,
					name: 'AI Headshot Generator',
					url: 'https://liftapp.ai/headshot-generator',
					description: 'Create professional headshots using AI.',
				},
				{
					'@type': 'SoftwareApplication',
					operatingSystem: 'Web',
					applicationCategory: 'MultimediaApplication',
					position: 3,
					name: 'AI Watermark Remover',
					url: 'https://liftapp.ai/watermark-remover',
					description: 'Remove watermarks from images using AI.',
				},
				{
					'@type': 'SoftwareApplication',
					operatingSystem: 'Web',
					applicationCategory: 'MultimediaApplication',
					position: 2,
					name: 'AI Anime Generator',
					url: 'https://liftapp.ai/anime-generator',
					description: 'Generate stunning AI anime art from your photos.',
				},
				{
					'@type': 'SoftwareApplication',
					operatingSystem: 'Web',
					applicationCategory: 'MultimediaApplication',
					position: 1,
					name: 'AI Cartoon Generator',
					url: 'https://liftapp.ai/cartoon-generator',
					description: 'Turn your photos into unique cartoons with AI.',
				},
			],
		},

		{
			'@type': 'SoftwareApplication',
			'@id': 'https://liftapp.ai/clothes-changer#all-in-one',
			name: 'Try Lift – AI Content Creation Tools',
			description:
				'Your all-in-one tools to create, edit, and elevate your content. Create stunning content with AI tools, templates, and editing features effortlessly.',
			operatingSystem: 'iOS, Android, Web',
			applicationCategory: 'MultimediaApplication',
			url: `${ENV.LIFT_WEB_APP_URL}/sign-in/?auto_login=true`,
			applicationSubCategory: 'Content Creation',
			publisher: {
				'@type': 'Organization',
				name: 'Lift',
				url: 'https://liftapp.ai',
			},
			potentialAction: [
				{
					'@type': 'ViewAction',
					name: 'Open Web App',
					target: `${ENV.LIFT_WEB_APP_URL}/sign-in/?auto_login=true`,
				},
			],
		},

		{
			'@type': 'BreadcrumbList',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Home',
					item: 'https://liftapp.ai',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Object Remover',
					item: 'https://liftapp.ai/clothes-changer',
				},
			],
		},
	],
};
